/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */

/**
 * 成果物種別 (何を書き込むか)。
 * 書込ルールが選択する成果物種別と、成果物記録が持つ成果物種別の両方でこの値域を共用します。
 * - `processing_result`: ワークフローの処理結果
 * - `bookmark`: 対象ファイルの詳細ページへのブックマーク (Box の Web Link)
 * フォーマット (JSON / CSV 等) はこの値域には含まれません (別のプロパティで表します)。
 */
export type ExportArtifactKind = typeof ExportArtifactKind[keyof typeof ExportArtifactKind];


export const ExportArtifactKind = {
  processing_result: 'processing_result',
  bookmark: 'bookmark',
} as const;
